import { getThemeForKey, Styles } from "@mcleod/core";

export const RadioBoxOptionStyles = Styles.make("rdbo", () => {
    return {
        boxOptionBase: {
            "&:focus-within": getThemeForKey("radioBoxOption.styleHoverBorder"),
            "&:hover": getThemeForKey("radioBoxOption.styleHoverBorder")
        },
        label: {
            display: "flex",
            alignItems: "center",
            "&:focus-visible": {
                outline: "none",
                border: "none"
            }
        },
        labelDisabled: {
            display: "flex",
            alignItems: "center",
            outline: "none",
            "&:focus-visible": {
                outline: "none",
                border: "none"
            },
        }
    };
});
